// extracted by mini-css-extract-plugin
module.exports =  {"modal-content-slim-header":"mZ1zxCP","modalContentSlimHeader":"mZ1zxCP","title":"Aibu7HS"};